import { ActionStatus, depascalize } from "sprint-common-web";

import { CloudFileStatus } from "../../../common/types/CloudFileStatus";
import { CloudFileListingItem } from "../../types/CloudFileListingItem";

export interface ApproveNotificationsItem {
    id: string;
    fileName: string;
    status: string;
    filePath?: string;
    isNotificationApproved?: boolean;
}

export type ProcessApproveNotificationsItem = ApproveNotificationsItem & {
    processStatus: ActionStatus;
};

export const mapToApproveNotificationsItem = (item: CloudFileListingItem): ApproveNotificationsItem => {
    return {
        id: item.id,
        fileName: item.deliveryFileName,
        status: depascalize(CloudFileStatus[item.status]),
        isNotificationApproved: item.isNotificationApproved,
        filePath: item.filePath
    };
};
